import { NgZone, EventEmitter, ɵɵinvalidFactory, ɵɵdefineDirective, ɵsetClassMetadata, Directive, Output, InjectionToken, ɵɵinject, ɵɵdefineInjectable, Injectable, Inject, ɵɵdirectiveInject, ElementRef, ɵɵlistener, Input, HostListener, ɵɵelement, ɵɵnextContext, ɵɵproperty, ɵɵelementStart, ɵɵtext, ɵɵpipe, ɵɵelementEnd, ɵɵadvance, ɵɵtextInterpolate1, ɵɵpipeBind2, ɵɵpureFunction1, ɵɵtemplate, ɵɵtextInterpolate, ɵɵgetCurrentView, ɵɵrestoreView, ɵɵdefineComponent, ɵɵstaticViewQuery, ɵɵqueryRefresh, ɵɵloadQuery, ɵɵNgOnChangesFeature, Component, ViewChild, ɵɵclassMap, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { Validators, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessageError, AlertType } from 'base-models';
import { __awaiter } from 'tslib';
import { AUTH_SERVICE_PROVIDER_TOKEN, AuthenticationServiceAbs } from 'baseauth';
import { NgIf, NgStyle, NgForOf, NgClass, DecimalPipe, CommonModule } from '@angular/common';
import { MessagebarComponent, MessagebarModule } from 'basecomponents';
import { PerfectScrollbarComponent, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MatDialogConfig, MatDialogContent, MatDialogActions, MatDialogClose, MatDialogModule } from '@angular/material/dialog';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

class UploadInfo {
}

function isElement(node) {
    return !!(node && (node.nodeName || node.prop && node.attr && node.find));
}
class FileLikeObject {
    constructor(fileOrInput) {
        let isInput = isElement(fileOrInput);
        let fakePathOrObject = isInput ? fileOrInput.value : fileOrInput;
        let postfix = typeof fakePathOrObject === 'string' ? 'FakePath' : 'Object';
        let method = '_createFrom' + postfix;
        this[method](fakePathOrObject);
    }
    _createFromFakePath(path) {
        this.lastModifiedDate = void 0;
        this.size = void 0;
        this.type = 'like/' + path.slice(path.lastIndexOf('.') + 1).toLowerCase();
        this.name = path.slice(path.lastIndexOf('/') + path.lastIndexOf('\\') + 2);
    }
    _createFromObject(object) {
        // this.lastModifiedDate = copy(object.lastModifiedDate);
        this.size = object.size;
        this.type = object.type;
        this.name = object.name;
    }
}

class FileItem {
    constructor(uploader, some, options) {
        this.alias = 'file';
        this.url = '/';
        this.method = 'POST';
        this.headers = [];
        this.withCredentials = true;
        this.formData = [];
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = false;
        this.isSuccess = false;
        this.isCancel = false;
        this.isError = false;
        this.progress = 0;
        this.index = void 0;
        this.uploader = uploader;
        this.some = some;
        this.options = options;
        this.file = new FileLikeObject(some);
        this._file = some;
        this.url = uploader.options.url;
        this._zone = new NgZone({ enableLongStackTrace: false });
    }
    upload() {
        try {
            this.uploader.uploadItem(this);
        }
        catch (e) {
            this.uploader._onCompleteItem(this, '', 0, []);
            this.uploader._onErrorItem(this, '', 0, []);
        }
    }
    cancel() {
        this.uploader.cancelItem(this);
    }
    remove() {
        this.uploader.removeFromQueue(this);
    }
    onBeforeUpload() {
        return void 0;
    }
    onBuildForm(form) {
        return { form };
    }
    onProgress(progress) {
        return { progress };
    }
    onSuccess(response, status, headers) {
        return { response, status, headers };
    }
    onError(response, status, headers) {
        this.errorServer = { response, status, headers };
        console.error(this.errorServer);
        return this.errorServer;
    }
    onCancel(response, status, headers) {
        return { response, status, headers };
    }
    onComplete(response, status, headers) {
        return { response, status, headers };
    }
    _onBeforeUpload() {
        this.isReady = true;
        this.isUploading = true;
        this.isUploaded = false;
        this.isSuccess = false;
        this.isCancel = false;
        this.isError = false;
        this.progress = 0;
        this.onBeforeUpload();
    }
    _onBuildForm(form) {
        this.onBuildForm(form);
    }
    _onProgress(progress) {
        this._zone.run(() => {
            this.progress = progress;
        });
        this.onProgress(progress);
    }
    _onSuccess(response, status, headers) {
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = true;
        this.isSuccess = true;
        this.isCancel = false;
        this.isError = false;
        this.progress = 100;
        this.index = void 0;
        this.onSuccess(response, status, headers);
    }
    _onError(response, status, headers) {
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = true;
        this.isSuccess = false;
        this.isCancel = false;
        this.isError = true;
        this.progress = 0;
        this.index = void 0;
        this.onError(response, status, headers);
    }
    _onCancel(response, status, headers) {
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = false;
        this.isSuccess = false;
        this.isCancel = true;
        this.isError = false;
        this.progress = 0;
        this.index = void 0;
        this.onCancel(response, status, headers);
    }
    _onComplete(response, status, headers) {
        this.onComplete(response, status, headers);
        if (this.uploader.options.removeAfterUpload) {
            this.remove();
        }
    }
    _prepareToUploading() {
        this.index = this.index || ++this.uploader._nextIndex;
        this.isReady = true;
    }
}

class FileType {
    static getMimeClass(file) {
        let mimeClass = 'application';
        if (this.mime_psd.indexOf(file.type) !== -1) {
            mimeClass = 'image';
        }
        else if (file.type.match('image.*')) {
            mimeClass = 'image';
        }
        else if (file.type.match('video.*')) {
            mimeClass = 'video';
        }
        else if (file.type.match('audio.*')) {
            mimeClass = 'audio';
        }
        else if (file.type === 'application/pdf') {
            mimeClass = 'pdf';
        }
        else if (this.mime_compress.indexOf(file.type) !== -1) {
            mimeClass = 'compress';
        }
        else if (this.mime_doc.indexOf(file.type) !== -1) {
            mimeClass = 'doc';
        }
        else if (this.mime_xsl.indexOf(file.type) !== -1) {
            mimeClass = 'xls';
        }
        else if (this.mime_ppt.indexOf(file.type) !== -1) {
            mimeClass = 'ppt';
        }
        if (mimeClass === 'application') {
            mimeClass = this.fileTypeDetection(file.name);
        }
        return mimeClass;
    }
    static fileTypeDetection(inputFilename) {
        let types = {
            'jpg': 'image',
            'jpeg': 'image',
            'tif': 'image',
            'psd': 'image',
            'bmp': 'image',
            'png': 'image',
            'nef': 'image',
            'tiff': 'image',
            'cr2': 'image',
            'dwg': 'image',
            'cdr': 'image',
            'ai': 'image',
            'indd': 'image',
            'pin': 'image',
            'cdp': 'image',
            'skp': 'image',
            'stp': 'image',
            '3dm': 'image',
            'mp3': 'audio',
            'wav': 'audio',
            'wma': 'audio',
            'mod': 'audio',
            'm4a': 'audio',
            'compress': 'compress',
            'rar': 'compress',
            '7z': 'compress',
            'lz': 'compress',
            'z01': 'compress',
            'pdf': 'pdf',
            'xls': 'xls',
            'xlsx': 'xls',
            'ods': 'xls',
            'mp4': 'video',
            'avi': 'video',
            'wmv': 'video',
            'mpg': 'video',
            'mts': 'video',
            'flv': 'video',
            '3gp': 'video',
            'vob': 'video',
            'm4v': 'video',
            'mpeg': 'video',
            'm2ts': 'video',
            'mov': 'video',
            'doc': 'doc',
            'docx': 'doc',
            'eps': 'doc',
            'txt': 'doc',
            'odt': 'doc',
            'rtf': 'doc',
            'ppt': 'ppt',
            'pptx': 'ppt',
            'pps': 'ppt',
            'ppsx': 'ppt',
            'odp': 'ppt'
        };
        let chunks = inputFilename.split('.');
        if (chunks.length < 2) {
            return 'application';
        }
        let extension = chunks[chunks.length - 1].toLowerCase();
        if (types[extension] === undefined) {
            return 'application';
        }
        else {
            return types[extension];
        }
    }
}
/*  MS office  */
FileType.mime_doc = [
    'application/msword',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    'application/vnd.ms-word.document.macroEnabled.12',
    'application/vnd.ms-word.template.macroEnabled.12'
];
FileType.mime_xsl = [
    'application/vnd.ms-excel',
    'application/vnd.ms-excel',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/vnd.ms-excel.template.macroEnabled.12',
    'application/vnd.ms-excel.addin.macroEnabled.12',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
];
FileType.mime_ppt = [
    'application/vnd.ms-powerpoint',
    'application/vnd.ms-powerpoint',
    'application/vnd.ms-powerpoint',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.presentationml.template',
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    'application/vnd.ms-powerpoint.addin.macroEnabled.12',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
];
/* PSD */
FileType.mime_psd = [
    'image/photoshop',
    'image/x-photoshop',
    'image/psd',
    'application/photoshop',
    'application/psd',
    'zz-application/zz-winassoc-psd'
];
/* Compressed files */
FileType.mime_compress = [
    'application/x-gtar',
    'application/x-gcompress',
    'application/compress',
    'application/x-tar',
    'application/x-rar-compressed',
    'application/octet-stream'
];

function isFile(value) {
    return (File && value instanceof File);
}
class FileUploader {
    constructor(options) {
        this.isUploading = false;
        this.queue = [];
        this.progress = 0;
        this._nextIndex = 0;
        this.onAfterAddingFileEvent = new EventEmitter();
        this.onAfterAddingAllEvent = new EventEmitter();
        this.options = {
            autoUpload: false,
            isHTML5: true,
            filters: [],
            removeAfterUpload: false
        };
        this.setOptions(options);
    }
    setOptions(options) {
        this.options = Object.assign(this.options, options);
        this.authToken = options.authToken;
        this.autoUpload = options.autoUpload;
        this.options.filters.unshift({ name: 'queueLimit', fn: this._queueLimitFilter });
        if (this.options.maxFileSize) {
            this.options.filters.unshift({ name: 'fileSize', fn: this._fileSizeFilter });
        }
        if (this.options.allowedFileType) {
            this.options.filters.unshift({ name: 'fileType', fn: this._fileTypeFilter });
        }
        if (this.options.allowedMimeType) {
            this.options.filters.unshift({ name: 'mimeType', fn: this._mimeTypeFilter });
        }
        // this.options.filters.unshift({name: 'folder', fn: this._folderFilter});
    }
    addToQueue(files, options, filters) {
        let list = [];
        for (let file of files) {
            list.push(file);
        }
        let arrayOfFilters = this._getFilters(filters);
        let count = this.queue.length;
        let addedFileItems = [];
        list.map((some) => {
            if (!options) {
                options = this.options;
            }
            let temp = new FileLikeObject(some);
            if (this._isValidFile(temp, arrayOfFilters, options)) {
                let fileItem = new FileItem(this, some, options);
                addedFileItems.push(fileItem);
                this.queue.push(fileItem);
                this._onAfterAddingFile(fileItem);
            }
            else {
                let filter = arrayOfFilters[this._failFilterIndex];
                this._onWhenAddingFileFailed(temp, filter, options);
            }
        });
        if (this.queue.length !== count) {
            this._onAfterAddingAll(addedFileItems);
            this.progress = this._getTotalProgress();
        }
        this._render();
        if (this.options.autoUpload) {
            this.uploadAll();
        }
    }
    removeFromQueue(value) {
        let index = this.getIndexOfItem(value);
        let item = this.queue[index];
        if (item.isUploading) {
            item.cancel();
        }
        this.queue.splice(index, 1);
        this.progress = this._getTotalProgress();
    }
    clearQueue() {
        while (this.queue.length) {
            this.queue[0].remove();
        }
        this.progress = 0;
    }
    uploadItem(value) {
        let index = this.getIndexOfItem(value);
        let item = this.queue[index];
        let transport = this.options.isHTML5 ? '_xhrTransport' : '_iframeTransport';
        item._prepareToUploading();
        if (this.isUploading) {
            return;
        }
        this.isUploading = true;
        this[transport](item);
    }
    cancelItem(value) {
        let index = this.getIndexOfItem(value);
        let item = this.queue[index];
        let prop = this.options.isHTML5 ? '_xhr' : '_form';
        if (item && item.isUploading) {
            item[prop].abort();
        }
    }
    uploadAll() {
        let items = this.getNotUploadedItems().filter((item) => !item.isUploading);
        if (!items.length) {
            return;
        }
        items.map((item) => item._prepareToUploading());
        items[0].upload();
    }
    cancelAll() {
        let items = this.getNotUploadedItems();
        items.map((item) => item.cancel());
    }
    isFile(value) {
        return isFile(value);
    }
    isFileLikeObject(value) {
        return value instanceof FileLikeObject;
    }
    getIndexOfItem(value) {
        return typeof value === 'number' ? value : this.queue.indexOf(value);
    }
    getIndexOfItemByFileName(value) {
        return this.queue.findIndex((item) => (item.file.name === value));
    }
    getItemByFileName(value) {
        return this.queue.find((item) => (item.file.name === value));
    }
    getNotUploadedItems() {
        return this.queue.filter((item) => !item.isUploaded);
    }
    getReadyItems() {
        return this.queue
            .filter((item) => (item.isReady && !item.isUploading))
            .sort((item1, item2) => item1.index - item2.index);
    }
    destroy() {
        return void 0;
        /*forEach(this._directives, (key) => {
         forEach(this._directives[key], (object) => {
         object.destroy();
         });
         });*/
    }
    onAfterAddingAll(fileItems) {
        return { fileItems };
    }
    onBuildItemForm(fileItem, form) {
        return { fileItem, form };
    }
    onAfterAddingFile(fileItem) {
        return { fileItem };
    }
    onWhenAddingFileFailed(item, filter, options) {
        return { item, filter, options };
    }
    onBeforeUploadItem(fileItem) {
        return { fileItem };
    }
    onProgressItem(fileItem, progress) {
        return { fileItem, progress };
    }
    onProgressAll(progress) {
        return { progress };
    }
    onSuccessItem(item, response, status, headers) {
        return { item, response, status, headers };
    }
    onErrorItem(item, response, status, headers) {
        return { item, response, status, headers };
    }
    onCancelItem(item, response, status, headers) {
        return { item, response, status, headers };
    }
    onCompleteItem(item, response, status, headers) {
        return { item, response, status, headers };
    }
    onCompleteAll() {
        return void 0;
    }
    _mimeTypeFilter(item) {
        return !(this.options.allowedMimeType && this.options.allowedMimeType.indexOf(item.type) === -1);
    }
    _fileSizeFilter(item) {
        return !(this.options.maxFileSize && item.size > this.options.maxFileSize);
    }
    _fileTypeFilter(item) {
        return !(this.options.allowedFileType &&
            this.options.allowedFileType.indexOf(FileType.getMimeClass(item)) === -1);
    }
    _onErrorItem(item, response, status, headers) {
        item._onError(response, status, headers);
        this.onErrorItem(item, response, status, headers);
    }
    _onCompleteItem(item, response, status, headers) {
        item._onComplete(response, status, headers);
        this.onCompleteItem(item, response, status, headers);
        let nextItem = this.getReadyItems()[0];
        this.isUploading = false;
        if (nextItem) {
            nextItem.upload();
            return;
        }
        this.onCompleteAll();
        this.progress = this._getTotalProgress();
        this._render();
    }
    _headersGetter(parsedHeaders) {
        return (name) => {
            if (name) {
                return parsedHeaders[name.toLowerCase()] || void 0;
            }
            return parsedHeaders;
        };
    }
    _xhrTransport(item) {
        let xhr = item._xhr = new XMLHttpRequest();
        let form = new FormData();
        this._onBeforeUploadItem(item);
        if (typeof item._file.size !== 'number') {
            throw new TypeError('The file specified is no longer valid');
        }
        this._onBuildItemForm(item, form);
        form.append(item.alias, item._file, item.file.name);
        /*     for (let x;x<item.formData.length;x++)
            {
                form.append("data"+x,item.formData[x]);
            } */
        /*     item.formData.forEach(element => {
                form.append("data",item.formData);
            }); */
        if (item.formData) {
            let inf = JSON.stringify(item.formData[0].info);
            console.log(inf);
            form.append("info", inf);
        }
        xhr.upload.onprogress = (event) => {
            let progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
            this._onProgressItem(item, progress);
        };
        xhr.onload = () => {
            let headers = this._parseHeaders(xhr.getAllResponseHeaders());
            let response = this._transformResponse(xhr.response, headers);
            let gist = this._isSuccessCode(xhr.status) ? 'Success' : 'Error';
            let method = '_on' + gist + 'Item';
            this[method](item, response, xhr.status, headers);
            this._onCompleteItem(item, response, xhr.status, headers);
        };
        xhr.onerror = () => {
            let headers = this._parseHeaders(xhr.getAllResponseHeaders());
            let response = this._transformResponse(xhr.response, headers);
            this._onErrorItem(item, response, xhr.status, headers);
            this._onCompleteItem(item, response, xhr.status, headers);
        };
        xhr.onabort = () => {
            let headers = this._parseHeaders(xhr.getAllResponseHeaders());
            let response = this._transformResponse(xhr.response, headers);
            this._onCancelItem(item, response, xhr.status, headers);
            this._onCompleteItem(item, response, xhr.status, headers);
        };
        xhr.open(item.method, item.url, true);
        xhr.withCredentials = false; //item.withCredentials;
        if (this.options.headers) {
            for (let header of this.options.headers) {
                xhr.setRequestHeader(header.name, header.value);
            }
        }
        if (this.authToken) {
            xhr.setRequestHeader('Authorization', this.authToken);
        }
        xhr.send(form);
        this._render();
    }
    _getTotalProgress(value = 0) {
        if (this.options.removeAfterUpload) {
            return value;
        }
        let notUploaded = this.getNotUploadedItems().length;
        let uploaded = notUploaded ? this.queue.length - notUploaded : this.queue.length;
        let ratio = 100 / this.queue.length;
        let current = value * ratio / 100;
        return Math.round(uploaded * ratio + current);
    }
    _getFilters(filters) {
        if (!filters) {
            return this.options.filters;
        }
        if (Array.isArray(filters)) {
            return filters;
        }
        if (typeof filters === 'string') {
            let names = filters.match(/[^\s,]+/g);
            return this.options.filters
                .filter((filter) => names.indexOf(filter.name) !== -1);
        }
        return this.options.filters;
    }
    _render() {
        return void 0;
        // todo: ?
    }
    // private _folderFilter(item:any):boolean {
    //   return !!(item.size || item.type);
    // }
    _queueLimitFilter() {
        return this.options.queueLimit === undefined || this.queue.length < this.options.queueLimit;
    }
    _isValidFile(file, filters, options) {
        this._failFilterIndex = -1;
        return !filters.length ? true : filters.every((filter) => {
            this._failFilterIndex++;
            return filter.fn.call(this, file, options);
        });
    }
    _isSuccessCode(status) {
        return (status >= 200 && status < 300) || status === 304;
    }
    /* tslint:disable */
    _transformResponse(response, headers) {
        // todo: ?
        /*var headersGetter = this._headersGetter(headers);
         forEach($http.deissues.transformResponse, (transformFn) => {
         response = transformFn(response, headersGetter);
         });*/
        return response;
    }
    /* tslint:enable */
    _parseHeaders(headers) {
        let parsed = {};
        let key;
        let val;
        let i;
        if (!headers) {
            return parsed;
        }
        headers.split('\n').map((line) => {
            i = line.indexOf(':');
            key = line.slice(0, i).trim().toLowerCase();
            val = line.slice(i + 1).trim();
            if (key) {
                parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
            }
        });
        return parsed;
    }
    /*private _iframeTransport(item:any) {
     // todo: implement it later
     }*/
    _onWhenAddingFileFailed(item, filter, options) {
        this.onWhenAddingFileFailed(item, filter, options);
    }
    _onAfterAddingFile(item) {
        this.onAfterAddingFile(item);
        this.onAfterAddingFileEvent.emit(item);
    }
    _onAfterAddingAll(items) {
        this.onAfterAddingAll(items);
        this.onAfterAddingAllEvent.emit(items);
    }
    _onBeforeUploadItem(item) {
        item._onBeforeUpload();
        this.onBeforeUploadItem(item);
    }
    _onBuildItemForm(item, form) {
        item._onBuildForm(form);
        this.onBuildItemForm(item, form);
    }
    _onProgressItem(item, progress) {
        let total = this._getTotalProgress(progress);
        this.progress = total;
        item._onProgress(progress);
        this.onProgressItem(item, progress);
        this.onProgressAll(total);
        this._render();
    }
    /* tslint:disable */
    _onSuccessItem(item, response, status, headers) {
        item._onSuccess(response, status, headers);
        this.onSuccessItem(item, response, status, headers);
    }
    /* tslint:enable */
    _onCancelItem(item, response, status, headers) {
        item._onCancel(response, status, headers);
        this.onCancelItem(item, response, status, headers);
    }
}
FileUploader.ɵfac = function FileUploader_Factory(t) { ɵɵinvalidFactory(); };
FileUploader.ɵdir = ɵɵdefineDirective({ type: FileUploader, outputs: { onAfterAddingFileEvent: "onAfterAddingFileEvent", onAfterAddingAllEvent: "onAfterAddingAllEvent" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FileUploader, [{
        type: Directive
    }], function () { return [{ type: undefined }]; }, { onAfterAddingFileEvent: [{
            type: Output
        }], onAfterAddingAllEvent: [{
            type: Output
        }] }); })();

const UPLOAD_SERVICE_CONFIG_TOKEN = new InjectionToken('UPLOAD_SERVICE_CONFIG');
const UPLOAD_SERVICE_CONFIG_DEFAULT = {
    baseUrl: "api/uploads"
};
/* export interface IUploadServiceConfig {
    baseUrl: string;
}
 */

/* config: IUploadServiceConfig, authService: AuthenticationServiceAbs) {
  return new UploadService(config, authService);
} */
/* @Injectable({
  providedIn: 'root',
  useFactory: (config: IUploadServiceConfig, authService: AuthenticationServiceAbs) =>
       new UploadService(config, authService),
  deps: [AuthenticationServiceAbs],
}) */
//@Injectable()
class UploadService {
    constructor(config, authService) {
        this.authService = authService;
        //@Input() zone: Zone;
        this.response = new EventEmitter();
        this.alertmessage = new EventEmitter();
        this.status = new EventEmitter();
        //SERVER_URL: string = AppConfig.API_ENDPOINT + "/uploads";//TODO:APPCONFIG
        this.SERVER_URL = "/uploads";
        this.uploader = new FileUploader({
            isHTML5: true
        });
        this.SERVER_URL = config.baseUrl;
        let currentUser = this.authService.currentUserValue;
        this.options = {
            url: this.SERVER_URL,
            filterExtensions: true
            //allowedMimeType: ['image/jpeg', 'image/jpg','image/tiff', 'image/tif', 'tmc']
            //, allowedExtensions: ['jpeg', 'jpg','tiff', 'tif', 'tmc1']
            /* allowedMimeType: ['image/jpeg', 'image/jpg','image/tiff', 'image/tif', 'tmc'], */
            /*       ,customHeaders: {
                    'custom-header-id-supervision': 'aaa-bbb-ccc'
                  }, */
            ,
            authToken: "JWT " + currentUser.token,
            disableMultipart: true,
            formatDataFunctionIsAsync: true,
            formatDataFunction: (item) => __awaiter(this, void 0, void 0, function* () {
                return new Promise((resolve, reject) => {
                    resolve({
                        name: item._file.name,
                        length: item._file.size,
                        contentType: item._file.type,
                        date: new Date()
                    });
                });
            })
        };
        this.uploader = new FileUploader(this.options);
    }
    getQueue() {
        return this.uploader.queue;
    }
    /*   public upload(data, userId) {
        let uploadURL = `${this.SERVER_URL}/auth/${userId}/avatar`;
    
        return this.httpClient.post<any>(uploadURL, data, {
          reportProgress: true,
          observe: 'events'
        }).pipe(map((event) => {
    
          switch (event.type) {
    
            case HttpEventType.UploadProgress:
              const progress = Math.round(100 * event.loaded / event.total);
              return { status: 'progress', message: progress };
    
            case HttpEventType.Response:
              return event.body;
            default:
              return `Unhandled event: ${event.type}`;
          }
        })
        );
      } */
    uploadAll() {
        this.uploader.uploadAll();
        this.status.emit({ status: "UPLOAD_ALL" });
    }
    cancelAll() {
        this.uploader.cancelAll();
        this.status.emit({ status: "CANCEL_ALL" });
    }
    clearQueue() {
        this.uploader.clearQueue();
        this.status.emit({ status: "CLEARQUEUE" });
    }
}
UploadService.ɵfac = function UploadService_Factory(t) { return new (t || UploadService)(ɵɵinject(UPLOAD_SERVICE_CONFIG_TOKEN), ɵɵinject(AUTH_SERVICE_PROVIDER_TOKEN)); };
UploadService.ɵprov = ɵɵdefineInjectable({ token: UploadService, factory: UploadService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UploadService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [UPLOAD_SERVICE_CONFIG_TOKEN]
            }] }, { type: AuthenticationServiceAbs, decorators: [{
                type: Inject,
                args: [AUTH_SERVICE_PROVIDER_TOKEN]
            }] }]; }, { response: [{
            type: Output
        }], alertmessage: [{
            type: Output
        }], status: [{
            type: Output
        }] }); })();

class FileDropDirective {
    constructor(element) {
        this.fileOver = new EventEmitter();
        this.onFileDrop = new EventEmitter();
        this.element = element;
    }
    getOptions() {
        return this.uploader.options;
    }
    getFilters() {
        return {};
    }
    onDrop(event) {
        let transfer = this._getTransfer(event);
        if (!transfer) {
            return;
        }
        let options = this.getOptions();
        let filters = this.getFilters();
        this._preventAndStop(event);
        this.uploader.addToQueue(transfer.files, options, filters);
        this.fileOver.emit(false);
        this.onFileDrop.emit(transfer.files);
    }
    onDragOver(event) {
        let transfer = this._getTransfer(event);
        if (!this._haveFiles(transfer.types)) {
            return;
        }
        transfer.dropEffect = 'copy';
        this._preventAndStop(event);
        this.fileOver.emit(true);
    }
    onDragLeave(event) {
        if (event.currentTarget === this.element[0]) {
            return;
        }
        this._preventAndStop(event);
        this.fileOver.emit(false);
    }
    _getTransfer(event) {
        return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
    }
    _preventAndStop(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    _haveFiles(types) {
        if (!types) {
            return false;
        }
        if (types.indexOf) {
            return types.indexOf('Files') !== -1;
        }
        else if (types.contains) {
            return types.contains('Files');
        }
        else {
            return false;
        }
    }
}
FileDropDirective.ɵfac = function FileDropDirective_Factory(t) { return new (t || FileDropDirective)(ɵɵdirectiveInject(ElementRef)); };
FileDropDirective.ɵdir = ɵɵdefineDirective({ type: FileDropDirective, selectors: [["", "ng2FileDrop", ""]], hostBindings: function FileDropDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("drop", function FileDropDirective_drop_HostBindingHandler($event) { return ctx.onDrop($event); })("dragover", function FileDropDirective_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("dragleave", function FileDropDirective_dragleave_HostBindingHandler($event) { return ctx.onDragLeave($event); });
    } }, inputs: { uploader: "uploader" }, outputs: { fileOver: "fileOver", onFileDrop: "onFileDrop" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FileDropDirective, [{
        type: Directive,
        args: [{ selector: '[ng2FileDrop]' }]
    }], function () { return [{ type: ElementRef }]; }, { uploader: [{
            type: Input
        }], fileOver: [{
            type: Output
        }], onFileDrop: [{
            type: Output
        }], onDrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }], onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], onDragLeave: [{
            type: HostListener,
            args: ['dragleave', ['$event']]
        }] }); })();

// todo: filters
class FileSelectDirective {
    constructor(element) {
        this.element = element;
    }
    getOptions() {
        return this.uploader.options;
    }
    getFilters() {
        return void 0;
    }
    isEmptyAfterSelection() {
        return !!this.element.nativeElement.attributes.multiple;
    }
    onChange() {
        // let files = this.uploader.isHTML5 ? this.element.nativeElement[0].files : this.element.nativeElement[0];
        let files = this.element.nativeElement.files;
        let options = this.getOptions();
        let filters = this.getFilters();
        // if(!this.uploader.isHTML5) this.destroy();
        this.uploader.addToQueue(files, options, filters);
        if (this.isEmptyAfterSelection()) {
            // todo
            // this.element.nativeElement.properties.value = '';
            /*this.element.nativeElement
             .replaceWith(this.element = this.element.nativeElement.clone(true)); // IE fix*/
        }
    }
}
FileSelectDirective.ɵfac = function FileSelectDirective_Factory(t) { return new (t || FileSelectDirective)(ɵɵdirectiveInject(ElementRef)); };
FileSelectDirective.ɵdir = ɵɵdefineDirective({ type: FileSelectDirective, selectors: [["", "ng2FileSelect", ""]], hostBindings: function FileSelectDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("change", function FileSelectDirective_change_HostBindingHandler() { return ctx.onChange(); });
    } }, inputs: { uploader: "uploader" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FileSelectDirective, [{
        type: Directive,
        args: [{ selector: '[ng2FileSelect]' }]
    }], function () { return [{ type: ElementRef }]; }, { uploader: [{
            type: Input
        }], onChange: [{
            type: HostListener,
            args: ['change']
        }] }); })();

const _c0 = ["frmsmessagebar"];
function FileUploadViewComponent_app_frms_messagebar_14_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "app-frms-messagebar", 16, 17);
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("alertmessage", ctx_r0.alertmessage);
} }
function FileUploadViewComponent_div_15_tr_29_td_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "td", 35);
    ɵɵtext(1);
    ɵɵpipe(2, "number");
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1("", ɵɵpipeBind2(2, 1, (item_r6 == null ? null : item_r6.file == null ? null : item_r6.file.size) / 1024 / 1024, ".2"), "Mb");
} }
const _c1 = function (a0) { return { "width": a0 }; };
function FileUploadViewComponent_div_15_tr_29_td_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "td");
    ɵɵelementStart(1, "div", 37);
    ɵɵelement(2, "div", 19);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(2);
    ɵɵproperty("ngStyle", ɵɵpureFunction1(1, _c1, item_r6.progress + "%"));
} }
function FileUploadViewComponent_div_15_tr_29_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 38);
    ɵɵelement(1, "i", 39);
    ɵɵelementEnd();
} }
function FileUploadViewComponent_div_15_tr_29_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 40);
    ɵɵelement(1, "i", 23);
    ɵɵelementEnd();
} }
function FileUploadViewComponent_div_15_tr_29_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 41);
    ɵɵelement(1, "i", 42);
    ɵɵelementEnd();
} }
function FileUploadViewComponent_div_15_tr_29_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "tr");
    ɵɵelementStart(1, "td");
    ɵɵtext(2);
    ɵɵelementStart(3, "strong");
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(5, FileUploadViewComponent_div_15_tr_29_td_5_Template, 3, 4, "td", 30);
    ɵɵtemplate(6, FileUploadViewComponent_div_15_tr_29_td_6_Template, 3, 3, "td", 13);
    ɵɵelementStart(7, "td", 31);
    ɵɵtemplate(8, FileUploadViewComponent_div_15_tr_29_span_8_Template, 2, 0, "span", 32);
    ɵɵtemplate(9, FileUploadViewComponent_div_15_tr_29_span_9_Template, 2, 0, "span", 33);
    ɵɵtemplate(10, FileUploadViewComponent_div_15_tr_29_span_10_Template, 2, 0, "span", 34);
    ɵɵelementEnd();
    ɵɵelementStart(11, "td", 35);
    ɵɵelementStart(12, "button", 20);
    ɵɵlistener("click", function FileUploadViewComponent_div_15_tr_29_Template_button_click_12_listener() { const item_r6 = ctx.$implicit; return item_r6.upload(); });
    ɵɵelement(13, "i", 21);
    ɵɵtext(14, " Upload ");
    ɵɵelementEnd();
    ɵɵelementStart(15, "button", 22);
    ɵɵlistener("click", function FileUploadViewComponent_div_15_tr_29_Template_button_click_15_listener() { const item_r6 = ctx.$implicit; return item_r6.cancel(); });
    ɵɵelement(16, "i", 23);
    ɵɵtext(17, " Cancel ");
    ɵɵelementEnd();
    ɵɵelementStart(18, "button", 36);
    ɵɵlistener("click", function FileUploadViewComponent_div_15_tr_29_Template_button_click_18_listener() { const item_r6 = ctx.$implicit; return item_r6.remove(); });
    ɵɵelement(19, "i", 25);
    ɵɵtext(20, " Remove ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r5.uishowparentname(item_r6));
    ɵɵadvance(2);
    ɵɵtextInterpolate(item_r6 == null ? null : item_r6.file == null ? null : item_r6.file.name);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.uploader.options.isHTML5);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.uploader.options.isHTML5);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", item_r6.isSuccess);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", item_r6.isCancel);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", item_r6.isError);
    ɵɵadvance(2);
    ɵɵproperty("disabled", item_r6.isReady || item_r6.isUploading || item_r6.isSuccess);
    ɵɵadvance(3);
    ɵɵproperty("disabled", !item_r6.isUploading);
} }
function FileUploadViewComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div");
    ɵɵelementStart(2, "div");
    ɵɵtext(3, " Queue progress: ");
    ɵɵelementStart(4, "div", 18);
    ɵɵelement(5, "div", 19);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(6, "button", 20);
    ɵɵlistener("click", function FileUploadViewComponent_div_15_Template_button_click_6_listener() { ɵɵrestoreView(_r18); const ctx_r17 = ɵɵnextContext(); return ctx_r17.uploadAll(); });
    ɵɵelement(7, "i", 21);
    ɵɵtext(8, " Upload all ");
    ɵɵelementEnd();
    ɵɵelementStart(9, "button", 22);
    ɵɵlistener("click", function FileUploadViewComponent_div_15_Template_button_click_9_listener() { ɵɵrestoreView(_r18); const ctx_r19 = ɵɵnextContext(); return ctx_r19.cancelAll(); });
    ɵɵelement(10, "i", 23);
    ɵɵtext(11, " Cancel all ");
    ɵɵelementEnd();
    ɵɵelementStart(12, "button", 24);
    ɵɵlistener("click", function FileUploadViewComponent_div_15_Template_button_click_12_listener() { ɵɵrestoreView(_r18); const ctx_r20 = ɵɵnextContext(); return ctx_r20.clearQueue(); });
    ɵɵelement(13, "i", 25);
    ɵɵtext(14, " Remove all ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(15, "perfect-scrollbar", 26);
    ɵɵelementStart(16, "table", 27);
    ɵɵelementStart(17, "thead");
    ɵɵelementStart(18, "tr");
    ɵɵelementStart(19, "th", 28);
    ɵɵtext(20, "Name");
    ɵɵelementEnd();
    ɵɵelementStart(21, "th");
    ɵɵtext(22, "Size");
    ɵɵelementEnd();
    ɵɵelementStart(23, "th");
    ɵɵtext(24, "Progress");
    ɵɵelementEnd();
    ɵɵelementStart(25, "th");
    ɵɵtext(26, "Status");
    ɵɵelementEnd();
    ɵɵelement(27, "th");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(28, "tbody");
    ɵɵtemplate(29, FileUploadViewComponent_div_15_tr_29_Template, 21, 9, "tr", 29);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(5);
    ɵɵproperty("ngStyle", ɵɵpureFunction1(5, _c1, ctx_r1.uploader.progress + "%"));
    ɵɵadvance(1);
    ɵɵproperty("disabled", ctx_r1.getNotUploadedItems().length == 0);
    ɵɵadvance(3);
    ɵɵproperty("disabled", !ctx_r1.isUploading());
    ɵɵadvance(3);
    ɵɵproperty("disabled", !ctx_r1.uploaderqueuefiltered.length);
    ɵɵadvance(17);
    ɵɵproperty("ngForOf", ctx_r1.uploaderqueuefiltered);
} }
const _c2 = function (a0) { return { "nv-file-over": a0 }; };
function FileUploadViewComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 43);
    ɵɵelementStart(1, "h3");
    ɵɵtext(2, "Select files");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 44);
    ɵɵlistener("fileOver", function FileUploadViewComponent_div_16_Template_div_fileOver_3_listener($event) { ɵɵrestoreView(_r22); const ctx_r21 = ɵɵnextContext(); return ctx_r21.fileOverBase($event); })("onFileDrop", function FileUploadViewComponent_div_16_Template_div_onFileDrop_3_listener($event) { ɵɵrestoreView(_r22); const ctx_r23 = ɵɵnextContext(); return ctx_r23.beforeUpload($event); });
    ɵɵtext(4, " Drop your files here ");
    ɵɵelementEnd();
    ɵɵtext(5, " or select using browser explorer ");
    ɵɵelement(6, "input", 45);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("ngClass", ɵɵpureFunction1(3, _c2, ctx_r2.hasBaseDropZoneOver))("uploader", ctx_r2.uploader);
    ɵɵadvance(3);
    ɵɵproperty("uploader", ctx_r2.uploader);
} }
function FileUploadViewComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 10);
    ɵɵelementStart(1, "div", 46);
    ɵɵelementStart(2, "div", 47);
    ɵɵelementStart(3, "div", 48);
    ɵɵtext(4, "Response");
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 49);
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(6);
    ɵɵtextInterpolate1(" ", ctx_r3.response, " ");
} }
/* // class FileSelectDirective
@Directive({ selector: '[ng2FileSelect]' })
// class FileDropDirective
@Directive({ selector: '[ng2FileDrop]' }) */
class FileUploadViewComponent {
    constructor(fb, uploadService) {
        this.fb = fb;
        this.uploadService = uploadService;
        this.showAddFiles = false;
        this.title = "Upload Queue";
        this.showAll = true;
        this.maxsizePerFile = 100000000; //10mb
        this.uploaderqueuefiltered = [];
        //const apiurlbase = AppConfig.API_ENDPOINT + '/api';  // URL to web api
        const apiurlbase = '/api'; // URL to web api
        const urlapi = `${apiurlbase}/uploads`;
        this.hasBaseDropZoneOver = false;
        this.response = '';
    }
    get uploader() {
        return this.uploadService.uploader;
    }
    ngOnInit() {
        this.uploadForm = this.fb.group({
            document: [null, null],
            type: [null, Validators.compose([Validators.required])]
        });
    }
    ngAfterViewInit() {
        //console.log("ngAfterViewInit");
        this.uploadService.response.subscribe(res => this.response = res);
        this.onAfterAddingAllEventSubscript = this.uploader.onAfterAddingAllEvent.subscribe(res => this.onAfterAddingAllEvent_handler(res));
        setTimeout(() => {
            this.configQueueToShow();
        });
    }
    ngOnDestroy() {
        //console.log("ngOnDestroy");
        this.onAfterAddingAllEventSubscript.unsubscribe();
    }
    ngOnChanges(changes) {
        console.log("FileUploadViewComponent ngOnChanges ", changes);
        const typeChange = changes['uploadinfo'];
        if (typeChange && !typeChange.firstChange) {
            this.uploadinfo = typeChange.currentValue;
            console.log(this.uploadinfo);
            this.configQueueToShow();
        }
    }
    configQueueToShow() {
        if (this.uploadinfo != null) {
            this.uploaderqueuefiltered = this.uploader.queue.filter(elem => elem.formData[0].info.parentid == this.uploadinfo.parentid);
        }
        else {
            if (this.showAll) {
                this.uploaderqueuefiltered = this.uploader.queue;
            }
        }
        return this.uploaderqueuefiltered;
    }
    onFileSelected() {
    }
    onAfterAddingAllEvent_handler(items) {
        console.log("onAfterAddingAllEvent_handler  ", this.uploadinfo);
        if (this.uploadinfo != null) {
            for (let x = 0; x < items.length; x++) {
                let item = items[x];
                let itemFormData = item.formData;
                let fileUploaInfo = new UploadInfo();
                Object.assign(fileUploaInfo, this.uploadinfo);
                fileUploaInfo.file = item.file.name;
                fileUploaInfo.filesize = item.file.size;
                fileUploaInfo.filetype = item.file.type;
                itemFormData.push({ "info": fileUploaInfo });
            }
            this.configQueueToShow();
        }
    }
    fileOverBase(e) {
        //console.log("fileOverBase",e);
        this.hasBaseDropZoneOver = e;
    }
    beforeUpload(files2Upload) {
        //console.log("fileOverBase",files2Upload);
        for (let x = 0; x < files2Upload.length; x++) {
            let file2 = files2Upload[x]; //no es un item to upload, el solo informacion del fichero
            let filename = file2.name;
            //let idx=this.uploader.getItemByFileName(filename);
            //console.log("idx",idx);
            let item = this.uploader.getItemByFileName(filename);
            //item.formData.push({'data':this.uploadinfo});
            let ext = filename.split('.').pop(); //obtenemos la extension, sino tiene devuelve el nombre completo del fichero
            if (filename == ext) {
                //console.log("ext", ext);
                //file without extension
                //item.setAbort();
                //item.remove();
            }
        }
    }
    uishowparentname(item) {
        if (!item) {
            return "";
        }
        if (item.formData.length > 0) {
            let uploadinfo = item.formData[0].info;
            return uploadinfo.parentname + " >>  ";
        }
    }
    /*   uploadSubmit() {
        for (let i = 0; i < this.uploader.queue.length; i++) {
          const fileItem = this.uploader.queue[i]._file;
          if (fileItem.size > 10000000) {
            this.alertmessage = new MessageError(AlertType.Error, "Each File should be less than 10 MB of size.");
            return;
          }
        }
        for (let j = 0; j < this.uploader.queue.length; j++) {
          let data = new FormData();
          let fileItem = this.uploader.queue[j]._file;
          console.log(fileItem.name);
          data.append('file', fileItem);
          data.append('fileSeq', 'seq' + j);
          data.append('dataType', this.uploadForm.controls.type.value);
          this.uploadFile(data).subscribe(data => this.adderrormessage(data.message));
        }
        this.uploader.clearQueue();
      } */
    /*   uploadFile(data: FormData): Observable<any> {
        return this.http.post('http://localhost:8080/upload', data);
      } */
    adderrormessage(msg) {
        const msgerr = new MessageError(AlertType.Error, msg);
        this.frmsmessagebar.addMessage(msgerr);
    }
    uploadAll() {
        let queue = this.configQueueToShow();
        for (let i = 0; i < queue.length; i++) {
            const fileItem = queue[i]._file;
            if (fileItem.size > this.maxsizePerFile) {
                let limsizestr = this.maxsizePerFile / 1000;
                this.alertmessage = new MessageError(AlertType.Error, "Each File should be less than " + limsizestr + " MB of size.");
                return;
            }
        }
        //this.uploadService.uploadAll();
        let items = queue.filter((item) => !item.isUploading);
        if (!items.length) {
            return;
        }
        items.map((item) => item._prepareToUploading());
        items[0].upload();
    }
    cancelAll() {
        let queue = this.configQueueToShow();
        queue = queue.filter((item) => !item.isUploaded);
        for (let item of queue) {
            item.cancel();
        }
        //this.uploadService.cancelAll();
    }
    clearQueue() {
        let queue = this.configQueueToShow();
        for (let item of queue) {
            item.remove();
        }
        //this.progress = 0;
        //this.uploadService.clearQueue();
    }
    getNotUploadedItems() {
        let queue = this.configQueueToShow();
        return queue.filter((item) => !item.isUploaded);
    }
    isUploading() {
        let queue = this.configQueueToShow();
        for (let item of queue) {
            if (item.isUploading) {
                return true;
            }
        }
        return false;
    }
}
FileUploadViewComponent.ɵfac = function FileUploadViewComponent_Factory(t) { return new (t || FileUploadViewComponent)(ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(UploadService)); };
FileUploadViewComponent.ɵcmp = ɵɵdefineComponent({ type: FileUploadViewComponent, selectors: [["app-fr-fileuploadview"]], viewQuery: function FileUploadViewComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0, true);
    } if (rf & 2) {
        let _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.frmsmessagebar = _t.first);
    } }, inputs: { title: "title", uploadinfo: "uploadinfo", showAll: "showAll", maxsizePerFile: "maxsizePerFile" }, features: [ɵɵNgOnChangesFeature], decls: 20, vars: 6, consts: [[1, "section-list", "card"], [1, "card-header"], [1, "navbar", "navbar-expand-sm", "navbar-light", "navbar-section-header", "justify-content-between", "section-header"], [1, "navbar-brand", "mb-0", "h1"], [1, "fas", "fa-list"], [1, "badge", "badge-primary"], ["id", "navbarSupportedContent", 1, "collapse", "navbar-collapse"], [1, "ml-auto", "d-flex", "justify-content-end"], [1, "card-body"], [1, "container-fluid"], [1, "row"], [1, "col", 2, "margin-bottom", "40px"], [3, "alertmessage", 4, "ngIf"], [4, "ngIf"], ["class", "col-3", 4, "ngIf"], ["class", "row", 4, "ngIf"], [3, "alertmessage"], ["frmsmessagebar", ""], [1, "progress", "mb-1"], ["role", "progressbar", 1, "progress-bar", 3, "ngStyle"], ["type", "button", 1, "btn", "btn-success", "btn-sm", 3, "disabled", "click"], [1, "fas", "fa-cloud-upload-alt"], ["type", "button", 1, "btn", "btn-warning", "btn-sm", 3, "disabled", "click"], [1, "fas", "fa-ban"], ["type", "button", 1, "btn", "btn-danger", "btn-sm", 3, "disabled", "click"], [1, "fas", "fa-minus-circle"], [2, "max-height", "300px"], [1, "table"], ["width", "50%"], [4, "ngFor", "ngForOf"], ["nowrap", "", 4, "ngIf"], [1, "text-center"], ["class", "text-success", 4, "ngIf"], ["class", "text-warning", 4, "ngIf"], ["class", "text-danger", 4, "ngIf"], ["nowrap", ""], ["type", "button", 1, "btn", "btn-danger", "btn-sm", 3, "click"], [1, "progress", 2, "margin-bottom", "0"], [1, "text-success"], [1, "fas", "fa-check-circle"], [1, "text-warning"], [1, "text-danger"], [1, "fas", "fa-exclamation-triangle"], [1, "col-3"], ["ng2FileDrop", "", 1, "card", "card-body", "bg-light", "my-drop-zone", 3, "ngClass", "uploader", "fileOver", "onFileDrop"], ["type", "file", "ng2FileSelect", "", "multiple", "", 2, "width", "100%", 3, "uploader"], [1, "col-md-12"], [1, "panel", "panel-default"], [1, "panel-heading"], [1, "panel-body"]], template: function FileUploadViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "nav", 2);
        ɵɵelementStart(3, "span", 3);
        ɵɵelement(4, "i", 4);
        ɵɵtext(5);
        ɵɵelementEnd();
        ɵɵelementStart(6, "span", 5);
        ɵɵtext(7);
        ɵɵelementEnd();
        ɵɵelementStart(8, "div", 6);
        ɵɵelement(9, "div", 7);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(10, "div", 8);
        ɵɵelementStart(11, "div", 9);
        ɵɵelementStart(12, "div", 10);
        ɵɵelementStart(13, "div", 11);
        ɵɵtemplate(14, FileUploadViewComponent_app_frms_messagebar_14_Template, 2, 1, "app-frms-messagebar", 12);
        ɵɵtemplate(15, FileUploadViewComponent_div_15_Template, 30, 7, "div", 13);
        ɵɵelementEnd();
        ɵɵtemplate(16, FileUploadViewComponent_div_16_Template, 7, 5, "div", 14);
        ɵɵelementEnd();
        ɵɵelement(17, "br");
        ɵɵelement(18, "br");
        ɵɵtemplate(19, FileUploadViewComponent_div_19_Template, 7, 1, "div", 15);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(5);
        ɵɵtextInterpolate1(" ", ctx.title, "");
        ɵɵadvance(2);
        ɵɵtextInterpolate1("Queued Files: ", ctx.uploaderqueuefiltered.length, "");
        ɵɵadvance(7);
        ɵɵproperty("ngIf", ctx.alertmessage);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", (ctx.uploader == null ? null : ctx.uploader.queue == null ? null : ctx.uploader.queue.length) > 0);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.uploadinfo);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.response);
    } }, directives: [NgIf, MessagebarComponent, NgStyle, PerfectScrollbarComponent, NgForOf, FileDropDirective, NgClass, FileSelectDirective], pipes: [DecimalPipe], styles: [".my-drop-zone[_ngcontent-%COMP%]{border:3px dotted #d3d3d3;color:#000;height:20vh}.nv-file-over[_ngcontent-%COMP%]{border:3px dotted red}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FileUploadViewComponent, [{
        type: Component,
        args: [{
                selector: 'app-fr-fileuploadview',
                templateUrl: './file-upload-view.component.html',
                styleUrls: ['./file-upload-view.component.scss']
            }]
    }], function () { return [{ type: FormBuilder }, { type: UploadService }]; }, { title: [{
            type: Input
        }], uploadinfo: [{
            type: Input
        }], showAll: [{
            type: Input
        }], maxsizePerFile: [{
            type: Input
        }], frmsmessagebar: [{
            type: ViewChild,
            args: ['frmsmessagebar', { static: true }]
        }] }); })();

class DialogUploadComponent {
    constructor() {
        this.title = "";
        this.uploadinfo = new UploadInfo();
        this.showAll = true;
        this.maxsizePerFile = 500000000;
    }
    ngOnInit() {
    }
    static openModalWithModel(dialog, title, uploadinfo, showAll = true, maxsizePerFile = 500000000, data) {
        const dialogConfig = new MatDialogConfig();
        let width = window.innerWidth;
        let widthStr = "900px";
        if (width > 1400) {
            widthStr = "1100px";
        }
        else {
            widthStr = "950px";
        }
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = widthStr;
        dialogConfig.data = data;
        let dialogRef;
        dialogRef = dialog.open(DialogUploadComponent, dialogConfig);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.uploadinfo = uploadinfo;
        dialogRef.componentInstance.maxsizePerFile = maxsizePerFile;
        dialogRef.componentInstance.showAll = showAll;
        return dialogRef;
    }
}
DialogUploadComponent.ɵfac = function DialogUploadComponent_Factory(t) { return new (t || DialogUploadComponent)(); };
DialogUploadComponent.ɵcmp = ɵɵdefineComponent({ type: DialogUploadComponent, selectors: [["app-upload-dialog"]], decls: 5, vars: 4, consts: [[3, "title", "uploadinfo", "maxsizePerFile", "showAll"], ["mat-dialog-actions", "", 1, "justify-content-end", 2, "width", "100%"], ["mat-raised-button", "", "mat-dialog-close", "", 1, "btn", "pull-right"]], template: function DialogUploadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-dialog-content");
        ɵɵelement(1, "app-fr-fileuploadview", 0);
        ɵɵelementEnd();
        ɵɵelementStart(2, "div", 1);
        ɵɵelementStart(3, "button", 2);
        ɵɵtext(4, "Close");
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("title", ctx.title)("uploadinfo", ctx.uploadinfo)("maxsizePerFile", ctx.maxsizePerFile)("showAll", ctx.showAll);
    } }, directives: [MatDialogContent, FileUploadViewComponent, MatDialogActions, MatButton, MatDialogClose], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DialogUploadComponent, [{
        type: Component,
        args: [{
                selector: 'app-upload-dialog',
                templateUrl: './dialog-upload.component.html',
                styleUrls: []
            }]
    }], function () { return []; }, null); })();

class UploadbarComponent {
    constructor(uploadService) {
        this.uploadService = uploadService;
        this.styleClass = "dropdown-header";
        this.showUploadViewEvent = new EventEmitter();
    }
    get uploader() {
        return this.uploadService.uploader;
    }
    ngOnInit() {
    }
    showAction() {
        this.showUploadViewEvent.emit();
    }
}
UploadbarComponent.ɵfac = function UploadbarComponent_Factory(t) { return new (t || UploadbarComponent)(ɵɵdirectiveInject(UploadService)); };
UploadbarComponent.ɵcmp = ɵɵdefineComponent({ type: UploadbarComponent, selectors: [["app-fr-uploadbar"]], inputs: { styleClass: "styleClass" }, outputs: { showUploadViewEvent: "showUploadViewEvent" }, decls: 8, vars: 3, consts: [[1, "dropdown-item", 3, "click"], [1, "fas", "fa-list"], [1, "badge", "badge-danger"]], template: function UploadbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div");
        ɵɵelementStart(1, "strong");
        ɵɵtext(2, "Loading files");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(3, "a", 0);
        ɵɵlistener("click", function UploadbarComponent_Template_a_click_3_listener() { return ctx.showAction(); });
        ɵɵelement(4, "i", 1);
        ɵɵtext(5, " Uploading Files ");
        ɵɵelementStart(6, "span", 2);
        ɵɵtext(7);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵclassMap(ctx.styleClass);
        ɵɵadvance(7);
        ɵɵtextInterpolate(ctx.uploader == null ? null : ctx.uploader.queue == null ? null : ctx.uploader.queue.length);
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UploadbarComponent, [{
        type: Component,
        args: [{
                selector: 'app-fr-uploadbar',
                templateUrl: './uploadbar.component.html',
                styleUrls: ['./uploadbar.component.scss']
            }]
    }], function () { return [{ type: UploadService }]; }, { styleClass: [{
            type: Input
        }], showUploadViewEvent: [{
            type: Output
        }] }); })();

class UploadFileData {
    constructor() {
        this.info = new InfoUploaded();
    }
}
class InfoUploaded {
}

var UploadTypeEnum;
(function (UploadTypeEnum) {
    UploadTypeEnum["flight"] = "flight";
    UploadTypeEnum["flight_thermal"] = "flight_thermal";
    UploadTypeEnum["flight_thermal_rjpeg"] = "flight_thermal_rjpeg";
    UploadTypeEnum["flight_rgb"] = "flight_rgb";
    UploadTypeEnum["supervision_radiation_data"] = "supervision_radiation_data";
    UploadTypeEnum["supervision_info"] = "supervision_info";
    UploadTypeEnum["site_info"] = "site_info";
    UploadTypeEnum["site_photo"] = "site_photo";
    UploadTypeEnum["user_photo"] = "user_photo";
    UploadTypeEnum["user_info"] = "user_info";
})(UploadTypeEnum || (UploadTypeEnum = {}));

const materialModules = [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    ScrollingModule
];
class MaterialModule {
}
MaterialModule.ɵmod = ɵɵdefineNgModule({ type: MaterialModule });
MaterialModule.ɵinj = ɵɵdefineInjector({ factory: function MaterialModule_Factory(t) { return new (t || MaterialModule)(); }, providers: [], imports: [[
            materialModules,
            DragDropModule
        ], MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        ScrollingModule, DragDropModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(MaterialModule, { imports: [MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        ScrollingModule, DragDropModule], exports: [MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        ScrollingModule, DragDropModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(MaterialModule, [{
        type: NgModule,
        args: [{
                imports: [
                    materialModules,
                    DragDropModule
                ],
                exports: [
                    materialModules,
                    DragDropModule
                ],
                entryComponents: [],
                declarations: [],
                providers: [],
            }]
    }], null, null); })();

function UploadServiceFactory(config, authService) {
    return new UploadService(config, authService);
}
class FileUploadModule {
    static forRoot(providedConfig = UPLOAD_SERVICE_CONFIG_DEFAULT) {
        return {
            ngModule: FileUploadModule,
            providers: [
                { provide: UPLOAD_SERVICE_CONFIG_TOKEN, useValue: providedConfig },
                UploadService
            ]
        };
    }
}
FileUploadModule.ɵmod = ɵɵdefineNgModule({ type: FileUploadModule });
FileUploadModule.ɵinj = ɵɵdefineInjector({ factory: function FileUploadModule_Factory(t) { return new (t || FileUploadModule)(); }, providers: [], imports: [[
            CommonModule,
            RouterModule,
            MaterialModule,
            FormsModule, ReactiveFormsModule,
            BsDropdownModule,
            PerfectScrollbarModule,
            MessagebarModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FileUploadModule, { declarations: [UploadbarComponent, FileUploadViewComponent, FileSelectDirective, FileDropDirective,
        DialogUploadComponent], imports: [CommonModule,
        RouterModule,
        MaterialModule,
        FormsModule, ReactiveFormsModule,
        BsDropdownModule,
        PerfectScrollbarModule,
        MessagebarModule], exports: [UploadbarComponent, FileUploadViewComponent, FileSelectDirective, FileDropDirective,
        DialogUploadComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(FileUploadModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule,
                    MaterialModule,
                    FormsModule, ReactiveFormsModule,
                    BsDropdownModule,
                    PerfectScrollbarModule,
                    MessagebarModule
                ],
                declarations: [
                    UploadbarComponent, FileUploadViewComponent, FileSelectDirective, FileDropDirective,
                    DialogUploadComponent
                ],
                entryComponents: [],
                exports: [
                    UploadbarComponent, FileUploadViewComponent, FileSelectDirective, FileDropDirective,
                    DialogUploadComponent
                ],
                providers: []
            }]
    }], null, null); })();

/*
 * Public API Surface of guploadmgr
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DialogUploadComponent, FileDropDirective, FileSelectDirective, FileUploadModule, FileUploadViewComponent, InfoUploaded, UPLOAD_SERVICE_CONFIG_DEFAULT, UPLOAD_SERVICE_CONFIG_TOKEN, UploadFileData, UploadInfo, UploadService, UploadServiceFactory, UploadTypeEnum, UploadbarComponent };
//# sourceMappingURL=guploadmgr.js.map
